
<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-form ref="form">
      <v-layout wrap justify-center>
        <v-flex xs12 v-if="showCoverImage.length < 1">
          <v-img
            width="100%"
            height="400px"
            :src="require('../../../../assets/images/slider1.png')"
            class="align-end"
          >
            <v-layout wrap justify-center pb-7>
              <v-flex xs6 lg3 align-self-center text-center>
                <CoverImageComp
                  @stepper="winStepper"
                  :height="'2118'"
                  :width="'8001'"
                  :heading="'Upload Cover Image'"
                  :componentType="'coverImage'"
                />
              </v-flex>
            </v-layout>
          </v-img>
        </v-flex>
        <v-flex xs12 v-else>
          <v-img
            width="100%"
            height="400px"
            :src="mediaURL + showCoverImage"
            class="align-end"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color=" #FDAC53"
                ></v-progress-circular>
              </v-row>
            </template>
            <v-layout wrap justify-center pb-7>
              <v-flex xs6 lg2 align-self-center text-center>
                <CoverImageComp
                  @stepper="winStepper"
                  :height="'2118'"
                  :width="'8001'"
                  :heading="'Upload Cover Image'"
                  :componentType="'coverImage'"
                />
              </v-flex>
            </v-layout>
          </v-img>
        </v-flex>
        <!-- <v-layout wrap justify-start>
          <v-flex xs6 text-center align-self-center py-5 class="RB clr"
            >EDIT SELLER PROFILE
          </v-flex>
        </v-layout> -->
        <v-flex xs12 md11>
          <v-tabs v-model="tab" background-color="white" color="#FEBD08" grow>
            <v-tab v-for="(item, i) in items" :key="i">{{ item.title }}</v-tab>
            <v-tab-item>
              <BasicDetails
                v-bind:sellerData="sellerData"
                :id="this.$route.query.seller"
                @stepper="winStepper"
              />
            </v-tab-item>
            <v-tab-item>
              <BankDetails v-bind:bank="bank" @stepper="winStepper" />
            </v-tab-item>
            <v-tab-item>
              <Working  v-if="$route.query.Type == 'foodSeller'"
                v-bind:working="workingHourss"
                v-bind:is24="is24X7"
                v-bind:uid="WorkingID"
                @stepper="winStepper"
              />
              <GroceryWorking v-if="$route.query.Type != 'foodSeller'" v-bind:storage="GroceryWork" />
             
            </v-tab-item>
            <v-tab-item v-if="sellerDetails">
              <ExtraDetails
                v-bind:categoryData="sellerDetails.category"
                v-bind:type="sellerDetails.type"
                v-bind:catId="sellerDetails.mainCategory"
                v-bind:parcelChargeData="sellerDetails.parcelCharge"
                v-bind:isPriceVary="sellerDetails.isPriceVary"
                @stepper="winStepper"
              />
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>


<script>
import axios from "axios";
import CoverImageComp from "./singleImage";
// import galleryComp from "./multipleImages";
import BasicDetails from "./basicDetails";
import BankDetails from "./bankDetails";
import Working from "./workingHours";
import GroceryWorking from "./groceryWorktime";
import ExtraDetails from "./extraDetails";

// import galleryComp from "./HM";
export default {
  components: {
    CoverImageComp,
    BankDetails,
    Working,
    ExtraDetails,
    // galleryComp,
    BasicDetails,
    GroceryWorking
  },
  data() {
    return {
      tab: null,
      items: [
        {
          title: " Profile Details",
          path: "profile",
        },
        { title: "  Bank Details", path: "bank" },
        { title: "Working Hours", name: "workHours" },
        { title: "Extra Details", name: "extraDetails" },
      ],
      sp: [],
      timeout: 3000,
      video: [],
      videoData: new FormData(),
      urlgallery: [],
      url7: [],
      marker: [],
      msg: "",

      showSnackBar: false,
      showCoverImage: "",
      coverImage: "",
      coverData: new FormData(),
      appLoading: false,
      hiveGallery: [],
      gallery: new FormData(),
      heading: "",
      description: "",
      name: "",
      phone: "",
      email: "",
      address: "",
      apiary: "",
      videoURL: "",
      sellerData: {
        shopName: null,
        instagram: null,
        whatsapp: null,
        facebook: null,
        description: null,
        city: null,
        pincode: null,
        place: null,
        contactPerson: null,
        email: null,
        lat: 0,
        lon: 0,
        photo: null,
      },
      sellerDetails: {},
      bank: {
        accountHolder: null,
        accountNo: null,
        bank: null,
        branch: null,
        ifsc: null,
        uid: null,
      },


        GroceryWork: {
        WorkTimeSwitch: false,
        startingTime: null,
        endingTime: null,
        uid: null,
      },
      workingHourss: [],
      is24X7: null,
      WorkingID: null,

      displayName: "",
      keeperDescription: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      imageFiles: [],
      imageArray: [],
      flag: true,
    };
  },

  mounted() {
    // this.getMap();
    this.getUser();
  },

  methods: {
    winStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.coverImage = window_data.selectedFiles;
        // console.log("cover image is", this.coverImageFile);
        this.coverImageUpload();
      }
      if (window_data.getData) this.getUser();
    },
    galleryStepper(window_data) {
      if (window_data.type == "image") {
        this.imageArray = window_data.imageArray;
        this.imageFiles.push(window_data.selectedFiles);
      } else if (window_data.type == "imageRemoval") {
        this.imageFiles.splice(window_data.removalItem, 1);
        this.imageArray = window_data.imageArray;
      } else if (window_data.type == "imageDeletion") {
        if (window_data.response.status) this.getUser();
      }
      // if (window_data.type == "coverImage") {
      //   this.hiveGallery.push(window_data.selectedFiles);
      //   this.urlgallery.push(window_data.selectedFiles);
      //   console.log("hive Gallery is", this.hiveGallery);
      //   console.log("url gallery is", this.urlgallery);
      // }
      if (window_data.getData) {
        this.getUser();
      }
    },
    // galleryStepper(window_data) {
    //   if (window_data.type == "coverImage") {
    //     this.hiveGallery.push(window_data.selectedFiles);
    //     this.urlgallery.push(window_data.selectedFiles);
    //     console.log("hive Gallery is", this.hiveGallery);
    //     console.log("url gallery is", this.urlgallery);
    //   }
    //   if (window_data.getData) {
    //     this.getUser();
    //   }
    // },

    unselect(value, item) {
      this.hiveGallery.splice(value, 1);
      this.urlgallery.splice(value, 1);
      this.sp = item;
      // console.log("the image name is", this.sp);
      this.deleteFomGallery(item);
    },

    getUser() {
      this.appLoading = true;
      // console.log(this.$route.query.Type, "gggg");
      axios({
        method: "GET",
        url: "/user/view/" + this.$route.query.seller,
        headers: {
          token: localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          if (this.$route.query.Type == "foodSeller")
           {
            this.sellerDetails = response.data.data.sellerid;
            if (response.data.data.sellerid.photo) {
              this.sellerData.photo =
                this.mediaURL + response.data.data.sellerid.photo;
            }
            if (response.data.data.sellerid.shopName) {
              this.sellerData.shopName = response.data.data.sellerid.shopName;
            }
            if (response.data.data.sellerid.email) {
              this.sellerData.email = response.data.data.sellerid.email;
            }
            if (response.data.data.sellerid.contactPerson) {
              this.sellerData.contactPerson =
                response.data.data.sellerid.contactPerson;
            }
            if (response.data.data.sellerid.place) {
              this.sellerData.place = response.data.data.sellerid.place;
            }
            if (response.data.data.sellerid.pincode) {
              this.sellerData.pincode = response.data.data.sellerid.pincode;
            }

            if (response.data.data.sellerid.city) {
              this.sellerData.city = response.data.data.sellerid.city;
            }
            if (response.data.data.sellerid.description) {
              this.sellerData.description =
                response.data.data.sellerid.description;
            }
            this.sellerData.facebook =
              response.data.data.sellerid.socialmedialinks.facebook;
            this.sellerData.whatsapp =
              response.data.data.sellerid.socialmedialinks.whatsapp;
            this.sellerData.instagram =
              response.data.data.sellerid.socialmedialinks.instagram;
            this.sellerData.uid = response.data.data._id;
            if (response.data.data.sellerid.bankDetails.accountHolder) {
              this.bank.accountHolder =
                response.data.data.sellerid.bankDetails.accountHolder;
            }
            if (response.data.data.sellerid.bankDetails.accountNo) {
              this.bank.accountNo =
                response.data.data.sellerid.bankDetails.accountNo;
            }
            if (response.data.data.sellerid.bankDetails.bank) {
              this.bank.bank = response.data.data.sellerid.bankDetails.bank;
            }
            if (response.data.data.sellerid.bankDetails.branch) {
              this.bank.branch = response.data.data.sellerid.bankDetails.branch;
            }
            if (response.data.data.sellerid.bankDetails.ifsc) {
              this.bank.ifsc = response.data.data.sellerid.bankDetails.ifsc;
            }
            this.bank.uid = response.data.data._id;

            this.workingHourss = response.data.data.sellerid.workingHour;
            this.is24X7 = response.data.data.sellerid.is24x7;
            this.WorkingID = response.data.data._id;

            this.appLoading = false;
            if (response.data.data.sellerid.coverPhoto) {
              this.showCoverImage = response.data.data.sellerid.coverPhoto;
            }

            this.sellerData.lat = response.data.data.sellerid.location[1];
            this.sellerData.lon = response.data.data.sellerid.location[0];
          }

          if (this.$route.query.Type == "grocerySeller") {
            this.sellerDetails = response.data.data.grocerySellerId;
            if (response.data.data.grocerySellerId.photo) {
              this.sellerData.photo =
                this.mediaURL + response.data.data.grocerySellerId.photo;
            }
            if (response.data.data.grocerySellerId.shopName) {
              this.sellerData.shopName = response.data.data.grocerySellerId.shopName;
            }
            if (response.data.data.grocerySellerId.email) {
              this.sellerData.email = response.data.data.grocerySellerId.email;
            }
            if (response.data.data.grocerySellerId.contactPerson) {
              this.sellerData.contactPerson =
                response.data.data.grocerySellerId.contactPerson;
            }
            if (response.data.data.grocerySellerId.place) {
              this.sellerData.place = response.data.data.grocerySellerId.place;
            }
            if (response.data.data.grocerySellerId.pincode) {
              this.sellerData.pincode = response.data.data.grocerySellerId.pincode;
            }

            if (response.data.data.grocerySellerId.city) {
              this.sellerData.city = response.data.data.grocerySellerId.city;
            }
            if (response.data.data.grocerySellerId.description) {
              this.sellerData.description =
                response.data.data.grocerySellerId.description;
            }
            this.sellerData.facebook =
              response.data.data.grocerySellerId.socialmedialinks.facebook;
            this.sellerData.whatsapp =
              response.data.data.grocerySellerId.socialmedialinks.whatsapp;
            this.sellerData.instagram =
              response.data.data.grocerySellerId.socialmedialinks.instagram;
            this.sellerData.uid = response.data.data._id;
            if (response.data.data.grocerySellerId.bankDetails.accountHolder) {
              this.bank.accountHolder =
                response.data.data.grocerySellerId.bankDetails.accountHolder;
            }
            if (response.data.data.grocerySellerId.bankDetails.accountNo) {
              this.bank.accountNo =
                response.data.data.grocerySellerId.bankDetails.accountNo;
            }
            if (response.data.data.grocerySellerId.bankDetails.bank) {
              this.bank.bank = response.data.data.grocerySellerId.bankDetails.bank;
            }
            if (response.data.data.grocerySellerId.bankDetails.branch) {
              this.bank.branch = response.data.data.grocerySellerId.bankDetails.branch;
            }
            if (response.data.data.grocerySellerId.bankDetails.ifsc) {
              this.bank.ifsc = response.data.data.grocerySellerId.bankDetails.ifsc;
            }
            this.bank.uid = response.data.data._id;
            this.GroceryWork.uid = response.data.data._id;

               this.GroceryWork.WorkTimeSwitch = response.data.data.grocerySellerId.isAlltimeDeliveryAvailable;
                  // this.GroceryWork.WorkTimeSwitch = true;
               
               

                this.GroceryWork.startingTime = response.data.data.grocerySellerId.deliveryTimeFrom;
                   this.GroceryWork.endingTime = response.data.data.grocerySellerId.deliveryTimeTo;

            this.workingHourss = response.data.data.grocerySellerId.workingHour;
            this.is24X7 = response.data.data.grocerySellerId.is24x7;
            this.WorkingID = response.data.data._id;

            this.appLoading = false;
            if (response.data.data.grocerySellerId.coverPhoto) {
              this.showCoverImage = response.data.data.grocerySellerId.coverPhoto;
            }

            this.sellerData.lat = response.data.data.grocerySellerId.location[1];
            this.sellerData.lon = response.data.data.grocerySellerId.location[0];
          }
        } else {
          this.appLoading = false;

          alert("failed to get email");
        }
      });
    },

    chooseCoverImage() {
      document.getElementById("coverImage").click();
    },
    chooseVideo() {
      document.getElementById("gallery").click();
    },
    browseVideo(file) {
      this.video = file.target.files[0];
      console.log("the video is", this.video);
    },
    browseToGallery(img) {
      for (let i = 0; i < img.length; i++) {
        this.hiveGallery.push(img[i]);
        this.url7.push(URL.createObjectURL(this.hiveGallery));
      }

      // this.hiveGallery = file.target.files;
      // console.log("gallery is", this.hiveGallery);
      console.log("hive gallary is=", this.hiveGallery);
      // this.uploadToGallery()
    },

    coverImageUpload() {
      this.coverData.append("uid", this.$route.query.seller);
      this.coverData.append("coverPhoto", this.coverImage);

       let getURL;
      if (this.$route.query.Type == "foodSeller") {
        getURL = "/admin/seller/edit";
      }
      if (this.$route.query.Type == "grocerySeller") {
        getURL = "/grocery/admin/seller/edit";
      }
      axios({
        method: "post",
        // url: "/admin/seller/edit",
          url: getURL,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.coverData,
      }).then((response) => {
        if (response.data.status) {
          this.showCoverImage = response.data.coverImage;
          this.coverData = new FormData();
          this.$router.go();
        } else {
          this.coverData = new FormData();
          this.showSnackBar = true;
          this.msg = "can't upload cover Image";
        }
      });
    },
  },
};
</script>

<style >
.center >>> input {
  text-align: center;
  font-family: robotobold;
}
.v-text-field >>> label {
  font-family: robotoregular;
  color: #d5d5d5;
}
#map44 {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>
